export const RESTORE_PAGES = 'RESTORE_PAGES';

export default uri => ({
  type: RESTORE_PAGES,
  uri,
});
